import { render, staticRenderFns } from "./SkillsMain.vue?vue&type=template&id=5de36bb5&scoped=true&"
import script from "./SkillsMain.vue?vue&type=script&lang=js&"
export * from "./SkillsMain.vue?vue&type=script&lang=js&"
import style0 from "./SkillsMain.vue?vue&type=style&index=0&id=5de36bb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de36bb5",
  null
  
)

export default component.exports